import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  padding: 16px;
  background-color: #1c1c1c;
  border-radius: 6px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const TextContainer = styled.div`
  margin-right: 33px;
  h4 {
    margin: 0;
    font-family: "Gilroy";
    font-weight: bold;
    margin-bottom: 24px;
    color: white;
  }
  p {
    color: white;
  }
`;

const QuestionMarkIcon = styled.div`
  display: flex;
  align-items: center;
`;

export default function HowToPlayCard() {
  return (
    <Container>
      <TextContainer>
        <h4>HOW TO PLAY</h4>
        <p>Find answers of most popular question here.</p>
      </TextContainer>
      <QuestionMarkIcon>
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="22.5" cy="22.5" r="22.5" fill="#0088D2" />
          <path
            d="M20.02 26.54C20.02 25.484 20.332 24.476 20.956 23.516C21.604 22.556 22.3 21.788 23.044 21.212C23.788 20.612 24.472 19.916 25.096 19.124C25.744 18.332 26.068 17.54 26.068 16.748C26.068 15.908 25.78 15.26 25.204 14.804C24.628 14.348 23.824 14.12 22.792 14.12C20.776 14.12 19.348 15.188 18.508 17.324L14.26 14.876C14.98 13.1 16.12 11.732 17.68 10.772C19.264 9.788 21.028 9.296 22.972 9.296C25.156 9.296 27.04 9.932 28.624 11.204C30.232 12.452 31.036 14.18 31.036 16.388C31.036 17.396 30.82 18.332 30.388 19.196C29.98 20.06 29.476 20.804 28.876 21.428C28.3 22.028 27.712 22.604 27.112 23.156C26.536 23.684 26.032 24.236 25.6 24.812C25.192 25.388 24.988 25.964 24.988 26.54H20.02ZM24.664 34.568C24.064 35.168 23.344 35.468 22.504 35.468C21.664 35.468 20.944 35.168 20.344 34.568C19.744 33.968 19.444 33.248 19.444 32.408C19.444 31.568 19.744 30.848 20.344 30.248C20.944 29.648 21.664 29.348 22.504 29.348C23.344 29.348 24.064 29.648 24.664 30.248C25.264 30.848 25.564 31.568 25.564 32.408C25.564 33.248 25.264 33.968 24.664 34.568Z"
            fill="#F0E500"
          />
        </svg>
      </QuestionMarkIcon>
    </Container>
  );
}
